import { content } from "../data/content";
import { PDFViewer } from "./shared/PDFViewer";

interface ResumePageProps {
  navigate: (to: string) => void;
}

export function ResumePage({ navigate }: ResumePageProps) {
  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans">
      <div className="max-w-5xl mx-auto px-6 py-6">
        <button
          onClick={() => navigate("/")}
          className="text-sm text-gray-400 hover:text-gray-900 transition-colors cursor-pointer mb-6"
        >
          &larr; Back
        </button>
        <div className="border border-black">
          <PDFViewer src={content.resume} />
        </div>
      </div>
    </div>
  );
}
